var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/solid/ic-checkbox-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66683 1.33398C2.82588 1.33398 1.3335 2.82637 1.3335 4.66732V11.334C1.3335 13.1749 2.82588 14.6673 4.66683 14.6673H11.3335C13.1744 14.6673 14.6668 13.1749 14.6668 11.334V4.66732C14.6668 2.82637 13.1744 1.33398 11.3335 1.33398H4.66683ZM5.00016 2.33398C3.5274 2.33398 2.3335 3.52789 2.3335 5.00065V11.0007C2.3335 12.4734 3.5274 13.6673 5.00016 13.6673H11.0002C12.4729 13.6673 13.6668 12.4734 13.6668 11.0007V5.00065C13.6668 3.52789 12.4729 2.33398 11.0002 2.33398H5.00016Z",
    fill: "#637381"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOff);
export default __webpack_public_path__ + "static/media/checkbox-off.6bf468e1f1ba4ecc773d7380e36a4a0c.svg";
export { ForwardRef as ReactComponent };